import type { FC } from 'react';

export const TrashIcon: FC<{
  color?: string;
}> = (props) => (
  <svg width="100%" height="100%" viewBox="0 0 8 10" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M0.666656 2.5H7.33332M5.66666 2.5L5.55391 2.1617C5.44461 1.83385 5.38995 1.66993 5.28861 1.54874C5.19911 1.44172 5.0842 1.35888 4.95436 1.30783C4.80732 1.25 4.63457 1.25 4.28899 1.25H3.71099C3.36541 1.25 3.19266 1.25 3.04562 1.30783C2.91579 1.35888 2.80086 1.44172 2.71136 1.54874C2.61001 1.66993 2.55537 1.83385 2.44609 2.1617L2.33332 2.5M6.49999 2.5V6.75C6.49999 7.45008 6.49999 7.80008 6.36374 8.0675C6.24391 8.30271 6.0527 8.49392 5.81749 8.61375C5.55007 8.75 5.20007 8.75 4.49999 8.75H3.49999C2.79992 8.75 2.44989 8.75 2.1825 8.61375C1.9473 8.49392 1.75607 8.30271 1.63623 8.0675C1.49999 7.80008 1.49999 7.45008 1.49999 6.75V2.5M4.83332 4.16667V7.08333M3.16666 4.16667V7.08333"
      stroke={props.color || '#E6E6E9'}
      stroke-width="0.833333"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);
